module.exports = __webpack_public_path__ + "36561df0a94861099c7229153ff7e2d4.cur";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/cur/circle-66.cur
// module id = 471
// module chunks = 0